import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGy = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 500 300", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 500, height: 300, fill: "#009e49" }), /* @__PURE__ */ React.createElement("path", { d: "M 0,0 L 500,150 L 0,300 z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M 0,13.05 L 456,150 L 0,286.95 z", fill: "#fcd116" }), /* @__PURE__ */ React.createElement("path", { d: "M 0,0 L 250,150 L 0,300 z", fill: "#000" }), /* @__PURE__ */ React.createElement("path", { d: "M 0,17.5 L 220.85,150 L 0,282.5 z", fill: "#ce1126" }));
const ForwardRef = forwardRef(SvgGy);
const Memo = memo(ForwardRef);
export default Memo;
